import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IAggregateLocationViewModel } from '../../user/models/iaggregate-location-view-model';
import { PagedEntity } from '../../user/models/paged-entity';
import { LocationHttpService } from './location-http.service';
import { IDayTimeFrameModel } from '@caslink/common-client';

@Injectable({
    providedIn: 'root'
})
export class LocationService {

    constructor(private locationHttpService: LocationHttpService) { }

    public getAggregateLocation(defaultLocationId: number) {
        return this.locationHttpService.get<IAggregateLocationViewModel>(`locations/${defaultLocationId}`);
    }

    public getPagedLocationsForCurrentUser(skip: number, count: number): Observable<PagedEntity<IAggregateLocationViewModel>> {
        return this.locationHttpService.get<PagedEntity<IAggregateLocationViewModel>>(`locations?skip=${skip}&take=${count}`);
    }

    public getLocationSubscriptionUrl(locationId: number): Observable<string> {
        return this.locationHttpService.get<string>(`locations/${locationId}/subscription/url`);
    }

    public getOccupancyForLocation(locationId: number) {
        return this.locationHttpService.get<IDayTimeFrameModel[]>(`locations/${locationId}/occupancy`);
    }

    public updateOccupancyForLocation(locationId: number, occupancy: IDayTimeFrameModel[]) {
        return this.locationHttpService.post(`locations/${locationId}/occupancy`, occupancy);
    }
}
